// React
import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';

// Context
import AuthContext from '../../authContext';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Store } from '../../redux/reducers';
import {
  getLogsAction,
  getParcelsWithIdAction,
  getParcelInventoryItemsAction,
  cleanPercelInventoryItemsAction,
  getInventoryItemsWithSerialAction,
} from '../parcels/actions';

// Selector
import { createStructuredSelector } from 'reselect';
import {
  makeSelectLogs,
  makeSelectParcel,
  makeSelectLoading,
  makeSelectError,
  makeSelectInventoryItemsList,
  makeSelectInventoryItemsLoading,
  makeSelectInventoryItemsCount,
  makeSelectInventoryItemsWithSerialList,
  makeSelectInventoryItemsWithSerialLoading,
} from '../parcels/selectors';

//UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import theme from '../../theme';
import {
  Typography,
  Paper,
  Grid,
  Button,
  CircularProgress,
  Box,
  ClickAwayListener,
  Card,
  CardHeader,
  CardContent,
  Dialog,
  DialogTitle,
  IconButton,
  Divider,
  DialogContent,
  TextField,
  MenuItem,
  DialogActions,
  Chip,
  Menu,
  FormHelperText,
} from '@material-ui/core';
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  Autocomplete,
} from '@material-ui/lab';

// Icon
import Icon from '@mdi/react';
import {
  mdiKeyOutline,
  mdiPrinter,
  mdiArchiveOutline,
  mdiDotsHorizontalCircleOutline,
  mdiMapMarkerCheckOutline,
  mdiClipboardCheckOutline,
  mdiClose,
  mdiFileTree,
  mdiPlaylistCheck,
  mdiArrowCollapseAll,
  mdiCheckBold,
  mdiClipboardArrowLeft,
  mdiTableCheck,
  mdiTableArrowUp,
  mdiChevronLeft,
  mdiCheckboxBlankCircle,
  mdiCircleMedium,
  mdiChatOutline,
} from '@mdi/js';

// Components
import ListParcelItems from './list';
import Can from '../../components/Can';
import CSV from './csv';
import InventoryItemCSV from './inventoryItemCsv';
import LabelList from '../parcelInventoryItems/components/labelsList';
import Modal from '../../components/Modal';
import DetailsMobile from './mobileView';
import { Controller, useForm } from 'react-hook-form';
import Client from 'client-sdk/src/client';
import { useHistory } from 'react-router-dom';
import { RonadDropzone } from '../../components/RonadDropzone';

// Helper
import {
  translate,
  formaterPhoneNumber,
  removeEmptyValueObject,
} from '../../utils/helpers';
import jMoment from 'moment-jalaali';
import windowSize from '../../utils/hook/useWindowResize';

// Type
import { SelectorProps, Props } from './interfaces';
import Pagination from '@material-ui/lab/Pagination';
import RenderFilter, { Filter } from '../../utils/listDaynamicFilter';
import clsx from 'clsx';
import useQuery from '../../utils/hook/useQuery';
import classes from './index.module.scss';
import { getCatAction } from '../orders/actions';
import {
  FileUploadTicketsRequestBuilder,
  PostAllTicketsRequestBuilder,
  GetAllCategoriesRequestBuilder,
} from 'client-sdk/src/helpical/categories';

import { GetAllDepartmentsRequestBuilder } from 'client-sdk/src/helpical/departments';

import handleNotfication from '../../utils/handleNotfication';
import handleError from '../../utils/handleError';
import { makeSelectCatList } from '../orders/selectors';
import Bell from '../../components/Notification/Bell';
import getAllDepartments from '../../requests/getAllDepartments';
import getAllCategories from '../../requests/getAllCategories';
import getAllTickets from '../../components/Notification/getAllTickets';
import TicketLink from '../../components/ticketLink';

const iconStatus = {
  ARRIVED: mdiMapMarkerCheckOutline, //'به مقصد رسیده',
  CANCELLED: mdiClose, //'لغو شده',
  SHIPPED: mdiDotsHorizontalCircleOutline, //'ارسال شده',
  DELIVERED: mdiClipboardCheckOutline, //'تحویل داده شده',
  SUBMITTED: mdiDotsHorizontalCircleOutline, //'ایجاد شده',
  ASSIGNED: mdiPlaylistCheck, // تخصیص داده شده
  REGISTERED: mdiCheckBold, //'منطبق شده',
  CONFLICTED: mdiArrowCollapseAll, // مغایرت داده شده
  LOCATED: mdiFileTree, // جایگذاری شده
  RETURNING: mdiClipboardArrowLeft, // ریجکت شده
  UNLOADING: mdiTableArrowUp, // در حال بارگذاری
  UNLOADED: mdiTableCheck, // تخلیه شده
};
const colorStatus = {
  SUBMITTED: theme.palette.green.main, //'ثپت شده',
  SHIPPED: theme.palette.green.main, //'ارسال شده',
  DELIVERED: theme.palette.green.main, //'تحویل داده شده',
  REGISTERED: theme.palette.green.main, //'منطبق شده',
  CANCELLED: theme.palette.error.main, //'لغو شده',
  RETURNING: theme.palette.warning.main, //'ریجکت شده',
  UNLOADING: theme.palette.orange.main, //'در حال بارگذاری ',
  UNLOADED: theme.palette.green.main, //'تخلیه شده',
  LOCATED: 'purple', // جایگذاری شده
  ASSIGNED: theme.palette.blue.main, // تخصیص داده شده
  CONFLICTED: theme.palette.orange.main, // مغایرت داده شده
};


const ticketPriority = [
  {
    id: 0,
    name: 'LOW',
    title: 'کم',
    color: '#007644',
    bcolor: '#e8faea',
  },
  {
    id: 1,
    name: 'NORMAL',
    title: 'متوسط',
    color: '#FF7E07',
    bcolor: '#ffeedf',
  },
  {
    id: 2,
    name: 'HIGH',
    title: 'زیاد',
    color: '#FF0000',
    bcolor: '#fffafa',
  },
  {
    id: 3,
    name: 'CRITICAL',
    title: 'اضطراری',
    color: 'maroon',
    bcolor: '#fffafa',
  },
];
const ticketType = [
  {
    id: 0,
    name: 'ORDER',
    title: 'سفارش',
    color: '#007644',
    bcolor: '#e8faea',
  },
  {
    id: 1,
    name: 'PARCEL',
    title: 'محموله',
    color: '#FF7E07',
    bcolor: '#ffeedf',
  },
  {
    id: 2,
    name: 'NONE',
    title: 'هیچکدام',
    color: '#FF0000',
    bcolor: '#fffafa',
  },
];

export function Details(props: Props) {
  const authContext = useContext(AuthContext);
  const [filters, setFilters] = useState([] as Filter[]);
  const { filtersValues, setFiltersValues } = useQuery(
    {
      parcelId: { equals: props.match.params.id },
      page: 0,
      size: 10000,
    } as any,
    ''
  );
  const [open, setOpen] = React.useState(false);
  const [printModal, setPrintModal] = useState(false as boolean);
  const [openFilterBox, setOpenFilterBox] = React.useState(false);
  const [selected, setSelected] = React.useState<string[]>([]);
  const [isMob, setIsMob] = useState(false);
  const { width } = windowSize();

  const [openMsg, setOpenMsg] = useState(false);
  const [file, setFile] = useState<any>('');
  const { register, control, errors, handleSubmit, setValue, getValues, watch } =
    useForm({
      defaultValues: {
        type: "PARCEL",
        file: null,
        title: null,
        priority: '',
        subject: '',
        msg: '',
        category: '',
        "parcel-order-number": (props.match.params.id ? props.match.params.id : ''),
      },
    });
  const [loading, setLoading] = useState(false);

  const [depts, setDepts] = useState<any[]>([
    { "id": 51, "name": "عملیات و انبار", "helpicalId": 11 },
    { "id": 52, "name": "ارسال و سفارشات", "helpicalId": 12 },
    { "id": 53, "name": "مالی", "helpicalId": 13 },
    { "id": 54, "name": "فنی", "helpicalId": 14 }
  ]);
  const [activeDepartment, setActiveDepartment] = useState<string | null | undefined>('');
  const [categories, setCategories] = useState<any[]>([]);

  const [activeCategory, setCategory] = useState<number | null | undefined>(undefined);
  const [hasTickets, setHasTickets] = useState<boolean>(false);

  const token = localStorage.getItem('token') || '';
  const history = useHistory();

  const handleCloseModal = () => {
    setOpenMsg(false);
    setActiveDepartment(null);
    setCategory(null);
  };

  const setupFilters = () => {
    setFilters([
      {
        type: 'input',
        id: 'productName.contains',
        label: 'نام کالا',
        icon: mdiArchiveOutline,
      },
      {
        type: 'input',
        id: 'productCode.contains',
        label: 'کد کالا',
        icon: mdiKeyOutline,
      },
      {
        type: 'number',
        id: 'productId.equals',
        label: 'شناسه کالا',
        icon: mdiKeyOutline,
      },
      {
        type: 'number',
        id: 'skuId.equals',
        label: 'شناسه تنوع کالا',
        icon: mdiKeyOutline,
      },
      {
        type: 'input',
        id: 'skuCode.contains',
        label: 'کد تنوع کالا',
        icon: mdiKeyOutline,
      },
      {
        type: 'input',
        id: 'serialNumber.equals',
        label: 'سریال کالا',
        icon: mdiKeyOutline,
      },
    ]);
  };

  useEffect(() => {
    if (width && width <= 480) {
      setIsMob(true);
    } else {
      setIsMob(false);
    }
  }, [width]);

  useEffect(() => {
    const { id } = props.match.params;
    // setValue("parcel-order-id", id);
    props.getLogsDispatch(id);
    props.getParcelWithIdActionDispatch(id);

    // props.getInventoryItemsWithSerialActionDispatch({
    //   ...filtersValues,
    // });
    return () => {
      props.clearnParcelInventoryItemsDispatch();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    getAllTickets({
      "parcelId.equals": props.match.params.id,
    }).then(response => {
      if (response.data.length > 0) {
        setHasTickets(true);
      } else {
        setHasTickets(false);
      }
    })
  }, []);

  useEffect(() => {
    props.getParcelInventoryItemDispatch({
      ...filtersValues,
    });
    setupFilters();
  }, [filtersValues]);

  const handleClickFilter = () => {
    setOpenFilterBox(prev => !prev);
  };

  useEffect(() => {
    setFiltersValues({
      parcelId: { equals: props.match.params.id },
      page: 0,
      size: 10000,
    });
  }, [printModal]);

  useEffect(() => {
    if (authContext.user.role !== 'SELLER_ADMIN') {
      try {
        handleActiveDeptChange();

      }
      catch {
        // console.log("WHOOPSY!");
      }
    }
  }, [activeDepartment]);

  const handleClickAway = (e: any) => {
    // TODO: Shet
    if (
      e.target.getAttribute('dir') !== 'rtl' &&
      e.target.getAttribute('type') !== 'checkbox' &&
      e.target.getAttribute('class') !== 'PrivateSwitchBase-input-73' &&
      e.target.getAttribute('class') !==
      'MuiTypography-root MuiListItemText-primary MuiTypography-body1 MuiTypography-displayBlock' &&
      e.target.getAttribute('aria-hidden') !== 'true'
    )
      setOpenFilterBox(false);
  };

  const handleOpenPrintModal = () => {
    setPrintModal(true);
  };

  const handleClosePrintModal = () => {
    setPrintModal(false);
  };

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelecteds = props.inventoryItems.map((n: any) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClickPrint = () => {
    props.history.push(
      `/print-labels/${props.match.params.id}?items=${selected.join(',')}`
    );
  };

  const handleClick = (
    event: React.ChangeEvent<HTMLInputElement>,
    id: string
  ) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected: string[] = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  /*
  const handleActiveDeptChange = () => {
    if (activeDepartment) {
      const response = getAllCategories({
        helpicalDepartmentId: activeDepartment,
      });
      response.then(catResponse => {
        setCategories(catResponse.data);
        console.log('categories by id: ', catResponse.data);
      });
    }
  }; */


  const handleActiveDeptChange = () => {
    if (activeCategory) {
      // console.log("changing active category, from ", activeCategory, " to null/undefined");
      setCategory(undefined);
      setValue('category', undefined);
    }
    if (activeDepartment) {
      const response = getAllCategories({
        helpicalDepartmentId: activeDepartment,
      });
      response.then(catResponse => {
        setCategories(catResponse.data);
        // console.log('categories by id: ', catResponse.data);
      });
    }
  };
  // const handleChangeFileInput = (event: any) => {
  //   setFile(event.target.files[0]);
  // };
  //
  const handleFileDropped = (acceptedFile: any) => {
    setFile(acceptedFile);
  };

  const onSubmit = async data => {
    try {
      setLoading(true);
      let fileData = new FormData();
      fileData.append('file', file);
      const makeRequest = new PostAllTicketsRequestBuilder()
        //REFACTOR: Data sending
        .params({})
        .data({
          orderId: null, //change for order details
          parcelId: (props.match.params.id ? props.match.params.id : 0),
          categoryId: activeCategory,
          message: data.msg,
          importance: data.priority,
          subject: data.title,

        })
        .build();
      const client = new Client(token);
      const response = await client.execute(makeRequest);
      if (file) {
        const fileTicketRequest = new FileUploadTicketsRequestBuilder()
          .id(response.data.id)
          .data(fileData)
          .build();
        await client.execute(fileTicketRequest);
      }

      handleNotfication('تیکت با موفقیت ایجاد شدند', 'success');
      history.push(`/parcels/details/${props.match.params.id}`);
    } catch (err) {
      if (err.response?.status === 400) {
        handleNotfication(err.response?.data?.title, 'error');
      }

      handleError(err.response);
    } finally {
      setFile(null);
      setOpenMsg(false);
      setLoading(false);
      setValue('file', null);
    }
  };

  const handleRemoveFile = () => {
    setFile(null);
    setValue('file', null);
  };
  {/*isMob ? (
    <DetailsMobile {...props} />
  ) :*/}
  return (
    <div className={classes.root}>
      {/* <Grid
        className={classes.topBox}
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Paper
          elevation={1}
          style={{
            width: '100%',
            borderRadius: '0',
          }}
        >
          <div className={classes.headerBox}>
            
            {authContext.user.role !== 'SELLER_ADMIN' && (

              <span style={{ display: 'flex', marginLeft: '172px' }}>
                {hasTickets &&
                  <Link to={`/alltickets/?parcelId.equals=${props.match.params.id}`}>
                    <Button
                      style={{ marginLeft: "8px" }}
                      variant="contained"
                      size="large"
                      color="primary"
                    >
                      {`سابقه تیکت`}
                    </Button>
                  </Link>
                }

                <Button
                  variant="contained"
                  size="large"
                  color="primary"
                  onClick={() => setOpenMsg(true)}
                >
                  {`تیکت جدید`}
                </Button>
                <TicketLink />
              </span>
            )}
          </div>
        </Paper>
      </Grid> */}
      <Typography variant="h6" component="h2" style={{marginBottom: "24px"}}>
              {`
        جزيیات محموله 
         `}
              <span data-cy="parcelId"> {props.parcel.id}</span>
            </Typography>
      <Grid
        container
        item
        lg={12}
        md={12}
        spacing={4}
        style={{ marginBottom: '32px' }}
      >
        <Grid item lg={3} md={3} xs={12} spacing={2}>
          <Card className={classes.card}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  اطلاعات محموله
                </Typography>
              }
            />
            <CardContent style={{ paddingBottom: '0' }}>
              <Grid item xs={12} sm={12} lg={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'وضعیت تحویل:  '}</span>
                  <span data-cy="parcelStatus">
                    {translate(props.parcel.status, 'parcel')}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'نام شرکت:  '}</span>
                  <span data-cy="parcelSellerName">
                    {props.parcel.partnerName ?? props.parcel.sellerName}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    {'تعداد آیتم های محموله:  '}
                  </span>

                  <span data-cy="inventoryItemsCount">
                    {props.inventoryItemsCount}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{'شناسه محموله:  '}</span>

                  <span data-cy="parcelId">{props.parcel.id}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{'تاریخ ثبت محموله:  '}</span>
                  <span>
                    <span data-cy="deliveryDate">
                      {props.parcel.deliveryDate &&
                        `${jMoment(props.parcel.shippingDate, 'YYYY/MM/DD')
                          .locale('fa')
                          .format('jYYYY/jMM/jDD')}`}
                    </span>
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{'تعداد تنوع کالا:  '}</span>

                  <span data-cy="itemsLength">
                    {props.parcel?.items?.length}
                  </span>
                </div>
              </Grid>

              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    {'تاریخ تحویل به انبار:  '}
                  </span>
                  <span>
                    <span data-cy="shippingDate">
                      {props.parcel.shippingDate &&
                        `${jMoment(props.parcel.deliveryDate, 'YYYY/MM/DD')
                          .locale('fa')
                          .format('jYYYY/jMM/jDD')}`}
                    </span>
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    {'بازه تحویل محموله:  '}
                  </span>
                  <span>
                    <span data-cy="deliveryStartTime">
                      {props.parcel.deliveryStartTime &&
                        jMoment(props.parcel.deliveryStartTime, 'hh:mm')
                          .locale('fa')
                          .format('HH:mm')}
                      {' - '}
                      {props.parcel.deliveryEndTime &&
                        jMoment(props.parcel.deliveryEndTime, 'hh:mm')
                          .locale('fa')
                          .format('HH:mm')}
                    </span>
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{'توضیحات:  '}</span>

                  <span data-cy="itemsLength">
                    {props.parcel.description}
                  </span>
                </div>
              </Grid>
            </CardContent>
          </Card>
          <Card className={classes.card}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  اطلاعات انبار مقصد
                </Typography>
              }
            />
            <CardContent style={{ paddingBottom: '0' }}>
              <Grid xs={12} sm={12} lg={12} spacing={2}>
                <div className={classes.item}>
                  <span className={classes.label}>{'انبار مقصد:  '}</span>

                  <span data-cy="destinationName">
                    {props.parcel.destinationName}
                  </span>
                </div>
              </Grid>

              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{'آدرس:  '}</span>
                  <span
                    data-cy="destinationAddress"
                    style={{ fontSize: '14px', textAlign: 'left' }}
                  >
                    {props.parcel.destinationAddress}
                  </span>
                </div>
              </Grid>
            </CardContent>
          </Card>
          <Card className={classes.card}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  اطلاعات مسئول حمل
                </Typography>
              }
            />
            <CardContent style={{ paddingBottom: '0' }}>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{'نام:  '}</span>

                  <span data-cy="agentName">{props.parcel.agentName}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{'شماره تماس:  '}</span>
                  <span data-cy="agentPhoneNumber">
                    {formaterPhoneNumber(props.parcel.agentPhoneNumber)}
                  </span>
                </div>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item lg={9} md={9} xs={12} spacing={2}>
          <Card className={classes.card} style={{ padding: 0 }}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  لیست کالاهای محموله
                </Typography>
              }
              action={
                <Grid item xs={12} style={{ marginTop: '15px' }}>
                  <div style={{ textAlign: 'left' }}>
                    <Button
                      variant="contained"
                      size="large"
                      color="primary"
                      onClick={() => setOpenMsg(true)}
                      style={{ marginLeft: '5px' }}
                    >
                      {`تیکت جدید`}
                    </Button>
                    <Can
                      role={authContext.user.role}
                      perform="/parcels/receipts/:id"
                      yes={() => (
                        <Link
                          to={`/parcels/receipts/${props.parcel.id}`}
                          target="_blank"
                          style={{ textDecoration: 'none' }}
                        >
                          <Button
                            style={{ marginLeft: '5px' }}
                            variant="contained"
                            color="secondary"
                            data-cy="printReceipts"
                            size="large"
                          >
                            {authContext.user.role === 'WAREHOUSE_OPERATOR' ||
                              authContext.user.role === 'WAREHOUSE_ADMIN'
                              ? 'چاپ رسید'
                              : 'چاپ حواله'}
                          </Button>
                        </Link>
                      )}
                    />
                    <Can
                      perform="parcels-details:print"
                      role={authContext.user.role}
                      yes={() => (
                        <Button
                          variant="contained"
                          color="primary"
                          size="large"
                          onClick={handleOpenPrintModal}
                          style={{ marginLeft: '5px' }}
                          data-cy="printId"
                        >
                          {'چاپ سریال'}
                        </Button>
                      )}
                    />
                    <Can
                      role={authContext.user.role}
                      perform="parcels-detail:downloadInventoryItemCSV"
                      yes={() => (
                        <>
                          {props.inventoryItemsWithSerial?.length && (
                            <InventoryItemCSV
                              ordersDispatch={
                                props.getInventoryItemsWithSerialActionDispatch
                              }
                              data={props.inventoryItemsWithSerial}
                              filtersValues={filtersValues}
                              loading={props.inventoryItemsWithSerialLoading}
                            />
                          )}
                        </>
                      )}
                    />
                    <Can
                      role={authContext.user.role}
                      perform="parcels-detail:downloadCSV"
                      yes={() => (
                        <>
                          {props.parcel?.items?.length && (
                            <CSV
                              ordersDispatch={
                                props.getParcelInventoryItemDispatch
                              }
                              data={props.parcel?.items}
                              filtersValues={filtersValues}
                              loading={props.inventoryItemsLoading}
                            />
                          )}
                        </>
                      )}
                    />
                  </div>
                </Grid>
              }
            />

            <CardContent style={{ margin: '15px 0  0', padding: '0' }}>
              {props.loading ? (
                <div className={classes.loading}>
                  <CircularProgress />
                </div>
              ) : (
                props.parcel?.items && (
                  <>
                    <ListParcelItems data={props.parcel.items} />
                  </>
                )
              )}
            </CardContent>
          </Card>
          <Card className={classes.card}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  تاریخچه محموله
                </Typography>
              }
            />
            <CardContent style={{ padding: '0', marginTop: '-10px' }}>
              <Grid container style={{ padding: '0' }}>
                <Grid item xs={12}>
                  <Timeline
                    align="left"
                    style={{
                      minWidth: '500px',
                    }}
                  >
                    {props.logs
                      ?.slice()
                      .reverse()
                      .map((log: Log, index: number) => (
                        <TimelineItem
                          className={classes.missingOppositeContent}
                          key={index}
                          data-cy="timeLineItem"
                        >
                          <TimelineSeparator>
                            <TimelineDot
                              style={{
                                backgroundColor: colorStatus[log.newStatus],
                                border: index === 0 ? 'solid 4px #DF9234' : '',
                              }}
                            >
                              <Icon
                                path={iconStatus[log.newStatus]}
                                size={0.5}
                              />
                            </TimelineDot>
                            {index !== props.logs?.length - 1 ? (
                              <TimelineConnector />
                            ) : (
                              ''
                            )}
                          </TimelineSeparator>
                          <TimelineContent className={classes.paperHistory}>
                            <div style={{ padding: '10px' }}>
                              <div className={classes.contentBox}>
                                <div style={{ flex: 2, textAlign: 'right' }}>
                                  <span className={classes.contentlabel}>
                                    وضعیت محموله:
                                  </span>
                                  <span data-cy="logStatus">
                                    {translate(log.newStatus, 'parcel')}
                                  </span>
                                </div>
                                <div
                                  style={{
                                    flex: 1,
                                    textAlign: 'right',
                                    justifyContent: 'center',
                                  }}
                                >
                                  <span className={classes.contentlabel}>
                                    کاربر:
                                  </span>
                                  <Can
                                    role={authContext.user.role}
                                    perform="user-name:dontShowInLogs"
                                    no={() => (
                                      <>
                                        <span>{log.modifierName}</span>
                                        <span>
                                          {' '}
                                          &nbsp; &nbsp;- &nbsp; &nbsp;
                                        </span>
                                      </>
                                    )}
                                  />
                                  <span data-cy="userRole">
                                    {translate(log.modifierRole, 'user')}
                                  </span>
                                </div>
                                <Typography
                                  component="div"
                                  className={classes.titleBox}
                                  style={{ flex: 1 }}
                                  data-cy="logTime"
                                >
                                  {log.time &&
                                    jMoment(log.time, 'YYYY/MM/DDTHH:mm:ss.SSZ')
                                      .locale('fa')
                                      .format('jYYYY/jMM/jDD - HH:mm')}
                                </Typography>
                              </div>
                            </div>
                          </TimelineContent>
                        </TimelineItem>
                      ))}
                  </Timeline>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item lg={3} md={3} spacing={2}></Grid>
      </Grid>
      {/*REFACTOR Extract dialoue*/}
      <Dialog
        open={openMsg}
        onClose={handleCloseModal}
        aria-labelledby="responsive-dialog-title"
        maxWidth="sm"
        fullWidth
        style={{ padding: '16px' }}
      >
        <DialogTitle>
          <Grid container justifyContent="center" justify="center">
            <p style={{ marginTop: '-8px' }}>ایجاد تیکت جدید</p>
          </Grid>
        </DialogTitle>

        <Grid container direction="column">
          <form onSubmit={handleSubmit(onSubmit)}>
            <DialogContent style={{ paddingTop: '0' }}>
              <Grid item md={12} lg={12}>
                <div style={{ marginTop: '2px' }}>
                  <Controller
                    style={{ width: '100%' }}
                    control={control}
                    name="title"
                    label="عنوان"
                    error={errors.title}
                    rules={{ required: true, minLength: 4 }}
                    as={
                      <TextField
                        style={{ marginTop: '16px', marginBottom: '16px' }}
                        fullWidth
                        variant="outlined"
                      ></TextField>
                    }
                  />
                </div>
                {errors.title?.type == "required" && <FormHelperText error focused>
                  عنوان الزامی می‌باشد
                </FormHelperText>}
                {errors.title?.type == "minLength" && <FormHelperText error focused>
                  حداقل 4کاراکتر وارد شود
                </FormHelperText>}
              </Grid>
              <br></br>
              <Grid container direction="row" spacing={2}>
                <Grid item md={4} lg={4}>
                  <Controller
                    style={{ width: '100%' }}
                    control={control}
                    id="type"
                    name="type"
                    label="مربوط به"
                    error={errors.type}
                    rules={{ required: false }}
                    as={
                      <TextField
                        style={{ marginTop: '16px', marginBottom: '16px' }}
                        fullWidth
                        variant="outlined"
                        select
                        disabled
                      >
                        {ticketType.map(item => {
                          return (
                            <MenuItem value={item.name}>
                              {item.title}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    }
                  />
                </Grid>
                <Grid item md={4} lg={4}>
                  <Controller
                    style={{ width: '100%' }}
                    control={control}
                    name="parcel-order-number"
                    label="شماره سفارش یا محموله"
                    rules={{ required: watch('type') != "NONE", pattern: /[0-9]/ }}
                    as={
                      <TextField
                        style={{ marginTop: '16px', marginBottom: '16px' }}
                        fullWidth
                        variant="outlined"
                        disabled
                      ></TextField>
                    }
                  />
                  {errors['parcel-order-number']?.type == "required" && <FormHelperText error focused>
                    شناسه سفارش یا محموله الزامی می‌باشد
                  </FormHelperText>}
                  {errors['parcel-order-number']?.type == "pattern" && <FormHelperText error focused>
                    فقط عدد وارد شود
                  </FormHelperText>}
                </Grid>

                <Grid item md={4} lg={4}>
                  <Controller
                    style={{ width: '100%' }}
                    control={control}
                    id="priority"
                    name="priority"
                    label="اولویت"
                    error={errors.priority}
                    rules={{ required: true }}

                    as={
                      <TextField
                        style={{ marginTop: '16px', marginBottom: '16px' }}
                        fullWidth
                        variant="outlined"
                        select
                      >
                        {ticketPriority.map(item => {
                          return (
                            <MenuItem value={item.name}>
                              <Chip
                                icon={
                                  <Icon
                                    path={mdiCircleMedium}
                                    size={1}
                                    color={item.color}
                                  />
                                }
                                label={item.title}
                                style={{
                                  color: item.color,
                                  backgroundColor: item.bcolor,
                                  fontSize: '16px',
                                }}
                              />
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    }
                  />
                  <FormHelperText error focused>
                    {errors.priority &&
                      "اولویت الزامی می‌باشد"
                    }

                  </FormHelperText>

                </Grid>
              </Grid>

              <Grid container direction="row" spacing={2}>
                <Grid item md={6} lg={6}>
                  <Autocomplete
                    id="department"
                    options={depts}
                    getOptionLabel={option => option.name}
                    disableClearable={true}
                    onChange={(e: any, newValue: any | null | undefined) => {
                      if (newValue) {
                        setActiveDepartment(newValue.helpicalId);
                        // console.log(
                        //   'changing active department to',
                        //   newValue,
                        //   'helpicalId: ',
                        //   newValue.helpicalId
                        // );
                        // handleActiveDeptChange();
                      } else if (newValue === '') {
                        // console.log('active dept is not found');
                      }
                    }}
                    renderInput={params => (
                      <TextField
                        name="department"
                        inputRef={register({ required: true })}
                        {...params}
                        label="دسته‌بندی"
                        fullWidth
                        variant="outlined"
                      />
                    )}
                  />
                  <FormHelperText error focused>
                    {errors.department &&
                      'دسته‌بندی الزامی میباشد'}
                  </FormHelperText>
                </Grid>

                <Grid item md={6} lg={6}>
                  <Autocomplete
                    id="category"
                    options={categories}
                    onChange={(event: any, newValue: any | null) => {
                      // console.log("New value: ", newValue, "its id: ", newValue.id)
                      setCategory(newValue.id);
                    }}
                    getOptionLabel={option => option?.name}
                    disableClearable={true}
                    renderInput={params => (
                      <TextField
                        fullWidth
                        {...params}
                        inputRef={register({ required: true })}
                        label="موضوع"
                        variant="outlined"
                        name="category"
                        disabled={!activeDepartment}
                      />
                    )}
                  />
                  <FormHelperText error focused>
                    {errors.category &&
                      'موضوع الزامی میباشد'}
                  </FormHelperText>
                </Grid>
              </Grid>
              <Controller
                control={control}
                id="msg"
                name="msg"
                rules={{ required: true }}
                error={errors.msg}
                as={
                  <TextField
                    inputProps={{
                      style: {
                        minHeight: '120px',
                        maxHeight: '240px',
                        padding: '0 8px',
                      },
                    }}
                    margin="normal"
                    multiline
                    label="متن پیام"
                    variant="outlined"
                    fullWidth
                  />
                }
              />

              <FormHelperText error focused>
                {errors.msg &&
                  "متن پیام الزامی است"
                }

              </FormHelperText>


              <Grid container direction="row" spacing={2}>
                <Grid item md={12} lg={12}>
                  <RonadDropzone
                    register={register}
                    onDropped={handleFileDropped}
                  />
                </Grid>
              </Grid>
              {file && (
                <Grid
                  style={{
                    textAlign: 'left',
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  <IconButton
                    aria-label="close"
                    style={{ marginLeft: 'auto' }}
                    onClick={handleRemoveFile}
                  >
                    <Icon path={mdiClose} size={1} />
                  </IconButton>
                  <span style={{ marginTop: '14px' }}>
                    <span style={{ fontWeight: 'bold' }}> {file.name} </span>
                    <span>( {file.size} KB )</span>
                  </span>
                </Grid>
              )}
            </DialogContent>
            <DialogActions>
              <Grid
                container
                spacing={1}
                direction="row-reverse"
                style={{ marginBottom: '8px' }}
              >
                <Grid item>
                  <Button
                    type="submit"
                    variant="contained"
                    size="large"
                    color="primary"
                    style={{ marginLeft: '24px' }}
                    disabled={loading}
                  >
                    {loading ? <CircularProgress style={{ height: "30px", width: "30px" }} /> : `ارسال پیام`}
                  </Button>
                </Grid>

                {handleCloseModal ? (
                  <Grid item>
                    <Button
                      type="submit"
                      variant="contained"
                      size="large"
                      color="default"
                      onClick={handleCloseModal}
                    >
                      {`بازگشت`}
                    </Button>
                  </Grid>
                ) : null}
              </Grid>
            </DialogActions>
          </form>
        </Grid>
      </Dialog>

      <Modal
        maxWidth="xl"
        onClose={handleClosePrintModal}
        open={printModal}
        title={
          <div style={{ textAlign: 'center' }}>
            <Icon path={mdiPrinter} size={4} color={theme.palette.green.main} />
          </div>
        }
        content={
          <Grid container>
            <Grid
              container
              justify="flex-end"
              item
              xs={12}
              style={{ marginBottom: '5px' }}
            >
              <ClickAwayListener onClickAway={handleClickAway}>
                <div>
                  <Button
                    type="button"
                    onClick={handleClickFilter}
                    className={classes.iconButton}
                    aria-label="search"
                  >
                    {openFilterBox ? 'بستن' : 'جستجوی پیشرفته'}
                  </Button>
                  {openFilterBox ? (
                    <div
                      className={clsx(classes.filterBox, {
                        [classes.filterOpen]: openFilterBox,
                      })}
                    >
                      <RenderFilter
                        filters={filters}
                        onFilter={(filtervalues: any) => {
                          setFiltersValues({
                            ...removeEmptyValueObject(filtervalues),
                            parcelId: { equals: props.match.params.id },
                            page: 0,
                            size: 100,
                          });
                          setOpenFilterBox(false);
                        }}
                        setOpenFilterBox={setOpenFilterBox}
                      />
                    </div>
                  ) : null}
                </div>
              </ClickAwayListener>
            </Grid>
            <Grid xs={12} style={{ marginBottom: '20px', marginTop: '20px' }}>
              <LabelList
                selected={selected}
                handleSelectAllClick={handleSelectAllClick}
                handleClick={handleClick}
                data={props.inventoryItems}
              />
            </Grid>
            <Box mb={4} />
            <Grid xs={12} container justify="space-between" alignItems="center">
              <Pagination
                count={Math.ceil(
                  props.inventoryItemsCount / filtersValues.size
                )}
                color="secondary"
                page={filtersValues.page + 1}
                onChange={handleChangePage}
              />
              <Button
                disabled={selected.length < 1}
                variant="contained"
                color="secondary"
                size="large"
                onClick={handleClickPrint}
                startIcon={<Icon path={mdiPrinter} size={1} />}
              >
                {'پرینت سریال‌ها'}
              </Button>
            </Grid>
          </Grid>
        }
      />
    </div>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  logs: makeSelectLogs(),
  catList: makeSelectCatList(),
  parcel: makeSelectParcel(),
  loading: makeSelectLoading(),
  inventoryItemsCount: makeSelectInventoryItemsCount(),
  inventoryItemsWithSerial: makeSelectInventoryItemsWithSerialList(),
  inventoryItemsWithSerialLoading: makeSelectInventoryItemsWithSerialLoading(),
  error: makeSelectError(),
  inventoryItems: makeSelectInventoryItemsList(),
  inventoryItemsLoading: makeSelectInventoryItemsLoading(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getLogsDispatch: (id: number) => dispatch(getLogsAction({ id })),
    getCatDispatch: (payload: any) => dispatch(getCatAction(payload)),
    getParcelWithIdActionDispatch: (id: number) =>
      dispatch(getParcelsWithIdAction({ id })),
    getParcelInventoryItemDispatch: (payload: object) =>
      dispatch(getParcelInventoryItemsAction(payload)),
    clearnParcelInventoryItemsDispatch: () =>
      dispatch(cleanPercelInventoryItemsAction()),
    getInventoryItemsWithSerialActionDispatch: (payload: Record<string, any>) =>
      dispatch(getInventoryItemsWithSerialAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Details);
